import { CashOutModalSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/CashOutModal/styles/CashOutModal.styles';

export const cashOutModalStyles: CashOutModalSchema = {
  modalContent: {
    bgGradient: 'linear(to-b, alpha.400, alpha.500)',
    boxShadow:
      '0px 0px 0px 2px rgba(252, 211, 96, 1) inset,0px 0px 0px 4px rgba(8, 13, 39, 1) inset,0px 0px 0px 5px #804284 inset,0px 7px 20px 0px rgba(0, 0, 0, 0.3)',
    sx: {
      '.chakra-modal__close-btn': {
        color: 'white',
      },
      '.chakra-modal__header': {
        color: 'beta.300',
      }
    },
  },
  stackWrapper: {},
  heading: { color: 'beta.300' },
  moneyValues: { color: 'white', textTransform: 'uppercase' },
  cashedOutText: {},
  cashedOutQuestion: { color: 'white' },
  declineButton: { textTransform: 'uppercase' },
  acceptButton: { variant: 'solid' },
  doneButton: {},
};
